import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'
import React, { useEffect } from 'react'

const options = ['subtopic', 'reference'];

function getTextOptionForType(type : string) {
    if (type === "subtopic") return "Subtopic"
    if (type === "reference") return "Reference"
    return type
}

function AssociationDialog( {mainTopicName, associationName, onSubmit, onCancel, ...props} : any ) {
    const [association, setAssociation] = React.useState({name: '', type: options[0]});

    const handleInputChange = (evt : any) => {
        const {name, value} = evt.target;
        setAssociation({
            ...association,
            [name]: value
        });
    };

    useEffect(() => {
        setAssociation({
            name: associationName,
            type: options[0]
        });
    }, [associationName]);

    return (
        <Dialog
            disableEscapeKeyDown
            maxWidth='md'
            aria-labelledby='association-dialog-title'
            onClose={onCancel}
            {...props}
        >
            <DialogTitle sx={{m: 0, p: 2, backgroundColor: '#6850ac', alignItems: 'center' }}  id='association-dialog-title' >
                <Typography fontWeight='bold' fontSize='22px' >New Association</Typography>
                <IconButton aria-label='close' onClick={onCancel} sx={{position: 'absolute', right: 12, top: 12}} >
                    <CloseIcon fontSize='large' />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{mt: 1}}>
                    {`Adds a new association for ${mainTopicName}`}
                </DialogContentText>
                <TextField name='name' label='Name of Associated Topic' variant='standard' fullWidth 
                    sx={{mt: 3}}
                    value={association.name} onChange={handleInputChange} 
                />
                <Grid container spacing={2} alignItems='center' sx={{ mt: 0 }} >
                    <Grid item  >
                        <Typography sx={{fontSize: 'large', fontWeight: 'ligth'}} >How are these topics associated: </Typography>
                    </Grid>
                    <Grid item>
                        <Select
                            aria-label='type'
                            name='type'
                            value={association.type}
                            onChange={handleInputChange}
                        > 
                        {options.map( (option) => 
                            <MenuItem value={option} key={option} > {getTextOptionForType(option)} </MenuItem>
                        )}
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { onSubmit(association) }} variant='contained' color='primary'>Add Association</Button>
            </DialogActions>
        </Dialog>
    );
}

export default AssociationDialog